import RestController from './RestController';
import BeatLoader from 'vue-spinner/src/BeatLoader';

$(function () {
    let elements = document.getElementsByClassName('car-service-calculator');

    for (let el of elements) {
        new Vue({
            el: el,
            components: {
                BeatLoader,
            },
            data: () => {
                return {
                    brands: [],
                    generations: [],
                    types: [],

                    service: 5,
                    brand: false,
                    generation: false,
                    type: false,

                    hsn: '',
                    tsn: '',
                    rest: null,
                    spinner_color: '#2588d9',
                };
            },
            async mounted() {
                this.rest = new RestController(vehicletree.resturl);
                await this.getBrands();
                if (typeof this.$refs.form.dataset.service !== 'undefined') {
                    this.service = parseInt(this.$refs.form.dataset.service);
                }
                if (typeof this.$refs.form.dataset.brand !== 'undefined') {
                    this.brand = this.brands.filter(brand => brand.id === parseInt(this.$refs.form.dataset.brand))[0].unique_vid;
                }
            },
            watch: {
                hsn: function (value) {
                    this.hsn = value.substring(0, 4);
                },
                tsn: function (value) {
                    this.tsn = value.toUpperCase();
                },
                brand: async function (value) {
                    this.reset(1);
                    this.generations = await this.rest.generations(this.brands.filter(brand => brand.unique_vid === value)[0].id);
                },
                generation: async function (value) {
                    this.reset(2);
                    this.types = await this.rest.types(this.brands.filter(brand => brand.unique_vid === this.brand)[0].id, this.generations.filter(generation => generation.unique_vid === value)[0].id);
                },
            },
            methods: {
                getBrands: async function () {
                    this.brands = await this.rest.brands();
                },
                reset: function (level) {
                    if (level <= 1) {
                        this.generations = [];
                        this.generation = false;
                    } else if (level > 2) {
                        this.types = [];
                        this.type = false;
                    }
                },
            },
        });
    }
});